const constants = {
  numberPattern: {
    nlNL: {
      regex: "^\\d{0,7}$|(?=^.{0,10}$)^\\d{0,7}\\,\\d{0,2}$",
      decimalSeparator: ",",
    },
    enGB: {
      regex: "^\\d{0,7}$|(?=^.{0,10}$)^\\d{0,7}\\.\\d{0,2}$",
      decimalSeparator: ".",
    },
    deDE: {
      regex: "^\\d{0,7}$|(?=^.{0,10}$)^\\d{0,7}\\,\\d{0,2}$",
      decimalSeparator: ",",
    },
  },
};
export default {
  ...constants,
};



// WEBPACK FOOTER //
// ./src/utils/constants.js